import React, { useState, useEffect, useRef } from "react";

import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const BlackTooltip = withStyles(() => ({
  tooltip: {
    maxWidth: "200px",
    backgroundColor: "#3F3F51",
    fontFamily: "Poppins_Medium",
    fontSize: "13px",
    padding: "8px 17px",
  },
}))(Tooltip);

export function PostRender({ rowData, rowIndex, t }) {
  const [disableHover, setDisableHover] = useState(true);
  const textContainer = useRef(null);

  useEffect(() => {
    if (
      textContainer.current &&
      textContainer.current.offsetWidth < textContainer.current.scrollWidth
    ) {
      setDisableHover(false);
    }
  }, []);

  const posteName = rowData?.poste?.title || t("Aucun");

  return (
    <div
      className="arh-p-0 arh-font-poppins arh-text-xs arh-font-medium arh-text-[#5a5a5a] hover:!arh-text-[#5a5a5a] "
    >
      <BlackTooltip
        placement="top"
        title={posteName}
        disableHoverListener={disableHover}
      >
        <span
          className={
            "posteName arh-block arh-overflow-hidden arh-text-ellipsis arh-truncate" +
            rowIndex
          }
          ref={textContainer}
        >
          {posteName}
        </span>
      </BlackTooltip>
    </div>
  );
}
